import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const CreacionPaletizacionApi = () => {
    const [cargando, setCargando] = useState(false);

    const getEVSProducidos = async (params) => {
        return api
            .get("paletizacion/evs_turno_actual", params)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getMetricasPaletizacion = async (idPaletizacion) => {
        try {
            setCargando(true);
            const response = await api.get(
                `paletizacion/${idPaletizacion}/metricas`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearPallet = async (idPaletizacion, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `paletizacion/${idPaletizacion}/crear_pallet_individual`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarPallet = async (idPallet) => {
        try {
            setCargando(true);
            const response = await api.eliminar(
                `paletizacion/eliminar_pallet/${idPallet}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarEstadoConformePallet = async (
        idPallet,
        conforme,
        tarjetaSalida,
    ) => {
        try {
            setCargando(true);

            const response = await api.post(
                `paletizacion/actualizar_estado_conforme/${idPallet}`,
                { es_conforme: conforme, tarjeta_salida: tarjetaSalida },
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const enviarABodega = async (idPaletizacion) => {
        try {
            setCargando(true);
            const response = await api.post(
                `paletizacion/${idPaletizacion}/enviar_a_bodega`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getSiguienteNumeroPallet = async () => {
        try {
            setCargando(true);

            const response = await api.get(
                "paletizacion/siguiente_numero_pallet",
            );
            return response.numero;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getPalletsRechazadosReutilizables = async (params) => {
        try {
            setCargando(true);

            const response = await api.get(
                "paletizacion/pallets_rechazados_reutilizables",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getEVSProducidos,
        getMetricasPaletizacion,
        crearPallet,
        eliminarPallet,
        actualizarEstadoConformePallet,
        enviarABodega,
        getSiguienteNumeroPallet,
        getPalletsRechazadosReutilizables,

        cargando,
    };
};
